export default import.meta.ROLLDOWN_FILE_URL_dTLQ2H5DzSpJior8R_PofA